import React, { useMemo } from 'react'
import './TmsExperienceStyles.css'

const TmsExperience = ({ transporter_data }) => {
    const totalYears = useMemo(() => {
        const experience = transporter_data?.tms_experience
        if (!experience || experience.length === 0) return 0
        return experience.reduce((total, tms) => {
            const parsedYears = parseInt(tms.years, 10)
            return Number.isNaN(parsedYears) ? total : total + parsedYears
        }, 0)
    }, [transporter_data])

    return (
        <div>
            <h3 className="data_header">Experience using TMS : {totalYears} year(s)</h3>
        </div>
    )
}

export default TmsExperience
